// Animation timing
const REFLOW_DELAY = 10;
const FOCUS_DELAY = 100;
const CLOSE_ANIMATION_DURATION = 600;

if (!customElements.get('personalization-pop-up')) {
  class PersonalizationPopup extends HTMLElement {
    constructor() {
      super();
      this.addtocartbtn = this.querySelector('.product-info__add-button>.btn');
      const modal_id = this.dataset.modalId;
      const modal = document.getElementById(modal_id);
      if (!modal) {
        console.error('[Personalization] Modal not found:', modal_id);
        return;
      }
      this.closebtn = modal.querySelector('.modal-content>.close');

      this.modal = modal;
      this.previewbtn = modal.querySelector('.modal-content button[name="preview"]');
      this.variantImage = modal.querySelector('.modal-content img[name="variant_media"]');
      this.variant_media_src = this.variantImage?.src || '';
      this.isPreview = false;
      this.isModalOpen = false; // Track modal open/close state
      this.personaledlines = modal.querySelector('.modal-content>.product-form__input');
      this.submitBtn = modal.querySelector('#myaddtocart');
      this.errorContainer = modal.querySelector('.personalization-server-error');

      this.bindEvents();
    }

    bindEvents() {
      // Store bound handlers for cleanup
      this.boundHandleAddToCart = this.handleAddtocartbtnClick.bind(this);
      this.boundHandleFormSubmit = this.handleFormSubmit.bind(this);
      this.boundHandlePreview = this.preview.bind(this);
      this.boundDocumentClickHandler = this.handleDocumentClick.bind(this);
      this.boundPointerDownHandler = (e) => {
        e.preventDefault();
        if (this.isModalOpen) this.close();
      };

      this.addtocartbtn.addEventListener('click', this.boundHandleAddToCart);
      if (this.closebtn) {
        // Use pointerdown for faster touch response; prevent default to avoid duplicate click
        this.closebtn.addEventListener('pointerdown', this.boundPointerDownHandler);
      }

      // Listen for multiple success events as themes vary on event names
      const successEvents = ['cart:added', 'cart:updated', 'cart:refresh', 'ajaxCart:success', 'theme:cartchanged'];
      this.boundSuccessHandlers = {};
      successEvents.forEach(evtName => {
        const handler = () => { if (this.isModalOpen) this.close(); };
        this.boundSuccessHandlers[evtName] = handler;
        document.addEventListener(evtName, handler);
      });

      // Note: We listen for multiple cart success events because different themes
      // dispatch different event types. Form 'submit' alone is unreliable since it fires
      // before server confirms the item was added.

      document.addEventListener('click', this.boundDocumentClickHandler);
      if (this.previewbtn)
        this.previewbtn.addEventListener('click', this.boundHandlePreview);

      // Reset preview state when user edits inputs (allows re-preview after typo fixes)
      this.boundHandleInputChange = this.handleInputChange.bind(this);
      if (this.modal) {
        this.modal.addEventListener('input', this.boundHandleInputChange);
      }

      this.form = document.getElementById(this.dataset.formId);
      if (this.form) {
        this.form.addEventListener('submit', this.boundHandleFormSubmit);
      }
    }

    disconnectedCallback() {
      // Clean up event listeners to prevent memory leaks
      if (this.addtocartbtn && this.boundHandleAddToCart) {
        this.addtocartbtn.removeEventListener('click', this.boundHandleAddToCart);
      }
      if (this.closebtn && this.boundPointerDownHandler) {
        this.closebtn.removeEventListener('pointerdown', this.boundPointerDownHandler);
      }
      if (this.previewbtn && this.boundHandlePreview) {
        this.previewbtn.removeEventListener('click', this.boundHandlePreview);
      }
      if (this.form && this.boundHandleFormSubmit) {
        this.form.removeEventListener('submit', this.boundHandleFormSubmit);
      }
      if (this.boundDocumentClickHandler) {
        document.removeEventListener('click', this.boundDocumentClickHandler);
      }
      if (this.modal && this.boundHandleInputChange) {
        this.modal.removeEventListener('input', this.boundHandleInputChange);
      }
      // Clean up success event listeners
      if (this.boundSuccessHandlers) {
        Object.entries(this.boundSuccessHandlers).forEach(([evtName, handler]) => {
          document.removeEventListener(evtName, handler);
        });
      }
    }

    handleFormSubmit(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      const submitBtn = this.submitBtn || this.form.querySelector('[type="submit"]');
      const errorContainer = this.errorContainer;

      if (errorContainer) {
        errorContainer.textContent = '';
        errorContainer.style.display = 'none';
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.value;
        submitBtn.value = 'Adding...';
      }

      const formData = new FormData(this.form);
      // Ensure the section rendering API updates the drawer if needed
      formData.append('sections', 'cart-drawer');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => { throw err; });
          }
          return response.json();
        })
        .then(data => {
          // Success: Dispatch theme event to update UI and close modal
          document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', {
              bubbles: true,
              detail: { openDrawer: true }
            })
          );
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          if (errorContainer) {
            errorContainer.textContent = error.description || error.message || 'Could not add item to cart. Please try again.';
            errorContainer.style.display = 'block';
            errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.value = submitBtn.dataset.originalText || 'Approve & Add to Cart';
          }
        });
    }
    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
    handleAddtocartbtnClick(evt) {
      const section_id = this.dataset.sectionId;
      const modal = this.modal;
      if (modal) {
        this.variant_media_src = this.variantImage?.src || '';
        this.isModalOpen = true;
        modal.style.display = "block";
        // Visual-only: add an 'open' class so CSS can animate a slide-up on mobile
        setTimeout(() => modal.classList.add('open'), REFLOW_DELAY);

        var parent_qty = document.getElementById("quantity-" + section_id);
        const quantityField = document.getElementById("quantity");
        if (quantityField) {
          if (parent_qty != null)
            quantityField.value = parent_qty.value;
          else
            quantityField.value = "1";
        }

        if (document && document.body) document.body.classList.add('personalization-modal-open');

        // Focus first input for accessibility
        const firstInput = modal.querySelector('.personalization-input');
        if (firstInput) setTimeout(() => firstInput.focus(), FOCUS_DELAY);
      }
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      const modal = this.modal;
      // Ignore if already closed or closing
      if (!modal || !this.isModalOpen) return;
      this.isModalOpen = false;
      // Visual-only: remove the 'open' class used for mobile slide-up so CSS can animate out
      modal.classList.remove('open');
      if (document && document.body) document.body.classList.remove('personalization-modal-open');
      // Wait for the animation to finish before hiding
      setTimeout(() => {
        modal.style.display = "none";
      }, CLOSE_ANIMATION_DURATION);

      //restore original
      if (this.variantImage) this.variantImage.src = this.variant_media_src;
      if (this.previewbtn) {
        this.previewbtn.textContent = "See Your Design";
        this.previewbtn.classList.remove('clear-mode');
      }
      if (this.submitBtn) this.submitBtn.disabled = true;
      this.isPreview = false;
    }
    handleDocumentClick(evt) {
      // Desktop Click-Outside: 
      // If target is mymodal (background), close.
      // If target is close button (or child), close.
      // If target is add-to-cart, we handled it separately (removed immediate close to wait for success).

      const isClickOutside = evt.target.matches('.mymodal');
      const isCloseBtn = evt.target.closest('.close');

      if (!isClickOutside && !isCloseBtn) return;

      // Stop propagation for click outside to prevent unwanted side effects
      if (isClickOutside) evt.stopPropagation();

      const form = document.getElementById(this.dataset.formId);
      if (form != null && !form.reportValidity()) {
        return;
      }

      // Close the modal if it's open
      if (this.isModalOpen) {
        // Only close if explicitly requested (outside click or close btn)
        this.close();
      }
    }
    handleInputChange(evt) {
      if (!evt.target.matches('.personalization-input')) return;
      if (!this.isPreview) return;

      // User edited text while preview was active — reset so they can re-preview
      this.isPreview = false;
      if (this.variantImage) this.variantImage.src = this.variant_media_src;
      if (this.previewbtn) {
        this.previewbtn.textContent = 'See Your Design';
        this.previewbtn.classList.remove('clear-mode', 'loading');
      }
      if (this.submitBtn) this.submitBtn.disabled = true;
    }

    preview() {
      //alert("preview");
      if (!this.isPreview) {
        this.isPreview = true;
        const personalization_inputs = this.modal.querySelectorAll('.modal-content .product-form__input .personalization-input');//.value.split('\n');
        var personaledlines = [];
        personalization_inputs.forEach((input) => {
          personaledlines.push(...input.value.split('\n'));
        });

        const skuInput = this.modal.querySelector('.modal-content input[name="sku"]');
        const sku = skuInput?.value || '';
        let lines = "";
        for (let i = 0; i < personaledlines.length; i++) {
          lines += "line" + (i + 1).toString() + "[" + this.urlEncode(personaledlines[i]) + "],";
        }
        const src = `http://evergreen.liquifire.com/evergreen?set=prodID[${sku}],${lines}version[web]&call=url[file:foundation/main]&scale=size[500]&sink=format[png]`;

        const img = this.variantImage;
        if (!img) return;

        const self = this;
        img.onload = function () {
          const previewbtn = document.getElementById("btnpreview");
          if (previewbtn && self.isPreview) {
            previewbtn.classList.remove("loading");
            previewbtn.textContent = "Clear Text";
            previewbtn.classList.add('clear-mode');
          }
        };
        img.src = src;
        if (this.previewbtn) {
          this.previewbtn.textContent = "Generating Preview...";
          this.previewbtn.classList.add('loading');
        }

        // Enable Add to Cart after preview is generated
        if (this.submitBtn) this.submitBtn.disabled = false;
      }
      else {
        this.isPreview = false;
        // Clear personalization inputs when clearing the preview
        const personalization_inputs = this.modal.querySelectorAll('.modal-content .product-form__input .personalization-input');
        personalization_inputs.forEach((input) => {
          if (!input) return;
          if (input.value) input.value = '';
          // Trigger validation that listens for input events so Preview gets disabled
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
        if (this.variantImage) this.variantImage.src = this.variant_media_src;
        if (this.previewbtn) {
          this.previewbtn.textContent = "See Your Design";
          this.previewbtn.classList.remove('clear-mode');
        }
        // Re-disable Add to Cart when clearing
        if (this.submitBtn) this.submitBtn.disabled = true;
      }
    }
    urlEncode(str)
    {
      str=str.replaceAll("&","U0026amp;").replaceAll("(","U0028").replaceAll(")","U0029");
      str=str.replaceAll("+","U002B").replaceAll("<","U0026lt;").replaceAll(">","U0026gt;");
      str=str.replaceAll("#","U0023");
      return str;
    }
  }

  customElements.define('personalization-pop-up', PersonalizationPopup);
}

// Input validation for preview button — scoped per modal instance
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mymodal').forEach(modal => {
    const previewButton = modal.querySelector('#btnpreview');
    const error = modal.querySelector('.personalization-error');
    if (!previewButton) return;

    function validate() {
      const inputs = modal.querySelectorAll('.personalization-input');
      const hasEmpty = [...inputs].some(input => input.value.trim() === '');
      previewButton.disabled = hasEmpty;
      if (!error) return;
      if (!hasEmpty) {
        error.style.display = 'none';
        error.textContent = '';
      } else {
        error.style.display = 'block';
        error.textContent = 'Enter personalization text to see your design';
        const addbtn = modal.querySelector('#myaddtocart');
        if (addbtn) addbtn.disabled = true;
      }
    }

    modal.addEventListener('input', (e) => {
      if (e.target.matches('.personalization-input')) validate();
    });

    validate();
  });
});
